/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Invitation_Already_AcceptedInputs */

const en_us2_group_invitation_already_accepted = /** @type {(inputs: Group_Invitation_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invitation was already accepted.`)
};

const pt_br2_group_invitation_already_accepted = /** @type {(inputs: Group_Invitation_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este convite já foi aceito.`)
};

const pt_pt2_group_invitation_already_accepted = /** @type {(inputs: Group_Invitation_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este convite já foi aceito.`)
};

/** @type {(inputs: Group_Invitation_Already_AcceptedInputs) => LocalizedString} */
const es_419_group_invitation_already_accepted = en_us2_group_invitation_already_accepted;

/** @type {(inputs: Group_Invitation_Already_AcceptedInputs) => LocalizedString} */
const fr_fr2_group_invitation_already_accepted = en_us2_group_invitation_already_accepted;

/** @type {(inputs: Group_Invitation_Already_AcceptedInputs) => LocalizedString} */
const de_de2_group_invitation_already_accepted = en_us2_group_invitation_already_accepted;

/** @type {(inputs: Group_Invitation_Already_AcceptedInputs) => LocalizedString} */
const it_it2_group_invitation_already_accepted = en_us2_group_invitation_already_accepted;

/**
* | output |
* | --- |
* | "This invitation was already accepted." |
*
* @param {Group_Invitation_Already_AcceptedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_invitation_already_accepted = /** @type {((inputs?: Group_Invitation_Already_AcceptedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Invitation_Already_AcceptedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_invitation_already_accepted(inputs)
	if (locale === "es-419") return es_419_group_invitation_already_accepted(inputs)
	if (locale === "pt-PT") return pt_pt2_group_invitation_already_accepted(inputs)
	if (locale === "fr-FR") return fr_fr2_group_invitation_already_accepted(inputs)
	if (locale === "de-DE") return de_de2_group_invitation_already_accepted(inputs)
	if (locale === "it-IT") return it_it2_group_invitation_already_accepted(inputs)
	return en_us2_group_invitation_already_accepted(inputs)
});
export { group_invitation_already_accepted as "group.invitation_already_accepted" }